export default {
  title: "Accept Corrective Work",
  content_confirm:
    "Are you sure you want to <b class='text-info'>accept</b> the <b class='text-info'>Performed Corrective</b> Work for this <b class='text-info'>Issue</b>?",
  content_undone: "This <b>cannot</b> be undone!",
  checkbox_label: "Close the <b class='text-info'>Issue</b>",
  input_label: "Comment",
}
